<template>
    <div class="full-chat-w single-page-container">
        <div class="content-box col-sm-8 col-xs-12">
            <div class="element-wrapper">
                <h6 class="element-header">
                    View Copy Desk Template
                </h6>
                <div class="element-box p-10">
                    <AddCopyTemplate :session-type="'copytemplate-update'" :channels="channels" :categories="categories" :headers="selectedHeaders" @stepInterface="onStepChange" @headerInterface="removeHeader" :templateData="templateData" />
                </div>
            </div>
        </div>
        <Loader v-if="isLoading == true" />
        <div class="content-panel col-sm-4  col-xs-hidden middle " v-else>
            <div class="content-panel-close">
                <i class="os-icon os-icon-close"></i>
            </div>
            <div class="element-wrapper" v-if="sideBarContent=='headers'">
                <h6 class="element-header">Headers</h6>
                <div class="element-box-tp">
                    <div class="input-search-w">
                        <input class="form-control rounded bright" v-model="headerSearch" placeholder="Search headers..." type="search">
                    </div>
                    <div class="users-list-w">
                        <div class="user-w" v-for="header in filteredHeaders">
                            <div class="user-avatar-w header-type">
                                <div class="user-avatar">
                                    <div :class="mapHeaderIcon(header.header_type)"></div>
                                </div>
                            </div>
                            <div class="user-name">
                                <h6 class="user-title">{{capitalize(header.header_name)}}</h6>
                                <div class="user-role">{{header.header_type}}</div>
                            </div>
                            <a class="user-action" @click="addHeader(header)">
                                <div class="fal fa-plus"></div>
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="element-wrapper" v-else>
                <h6 class="element-header">Guide</h6>
                <div class="element-box-tp">
                    <div class="todo-list">
                        <a class="todo-item">
                            <div class="ti-info">
                                <div class="ti-header">Channel is required</div>
                            </div>
                        </a>
                        <a class="todo-item" >
                            <div class="ti-info">
                                <div class="ti-header">Category is required</div>
                            </div>
                        </a>
                        <a class="todo-item" >
                            <div class="ti-info">
                                <div class="ti-header">Atleast one visible header is required</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/common/Loader'
import AddCopyTemplate from '@/components/common/Forms/AddCopyTemplate'

import CommonFunctions from '@/mixins/common-functions.js'

export default {
  props: ['id_copydesk_template'],

  mixins: [CommonFunctions],
  components: { AddCopyTemplate, Loader },

  data () {
    return {
      sideBarContent: 'others',
      channels: '',
      categories: '',
      headers: '',
      templateData: '',
      filteredHeaders: [],
      selectedHeaders: [],
      headerSearch: '',
      isLoading: true
    }
  },
  mounted () {
    this.getFormParameters()
  },
  methods: {
    getFormParameters () {
      var self = this

      const url = '/copydesk/templates/view'
      let data = {
        id_copy_template: parseInt(self.id_copydesk_template)
      }

      self.isLoading = true

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.templateData = response.data.template_data
          self.categories = response.data.categories
          self.headers = self.filteredHeaders = response.data.headers
          self.selectedHeaders = response.data.template_headers
          self.isLoading = false
          self.updateHeader()
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: error.response.data || 'Something went wrong',
            show: true
          })
          self.isLoading = false
        })
    },
    addHeader (header) {
      this.selectedHeaders.push(header)
      this.$store.dispatch('updateToast', {
        text: 'Header added to template',
        show: true
      })
      this.updateHeader()
    },
    removeHeader (data) {
      for (var i = 0; i < this.selectedHeaders.length; i++) {
        if (
          this.selectedHeaders[i].id_copy_template_header ===
          data.id_copy_template_header
        ) {
          this.selectedHeaders.splice(i, 1)
          break
        }
      }
      this.$store.dispatch('updateToast', {
        text: 'Header removed to template',
        show: true
      })
      this.updateHeader()
    },
    updateHeader () {
      this.filteredHeaders = this.headers.filter(
        item =>
          !this.selectedHeaders.includes(item) &&
          item.header_name.indexOf(this.headerSearch) > -1
      )
    },
    onStepChange (data) {
      this.sideBarContent = data
    }
  },
  watch: {
    headerSearch () {
      this.updateHeader()
    }
  }
}
</script>

<style scoped>
.single-page-container {
  padding: 20px;
}
.content-panel {
  padding: 1rem;
}
.header-type {
  font-size: 25px;
  text-align: center;
}
</style>
